// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2ZvR1","additionalInfo":"AgreementModal_additionalInfo__3zCBF"};